<template>
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="120" height="120" rx="60" fill="#4E555A"></rect>
    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
      <rect width="120" height="120" rx="60" fill="#D9D9D9"></rect>
    </mask>
    <g mask="url(#mask0)">
      <path d="M60 25C46.7657 25 36 35.7657 36 49C36 62.2343 46.7657 73 60 73C73.2343 73 84 62.2343 84 49C84 35.7657 73.2343 25 60 25Z" fill="#E8E8F6"></path>
      <path d="M101.53 104.882C84.7199 79.706 35.2801 79.706 18.4704 104.882L18 105.586V126H102L102 105.586L101.53 104.882Z" fill="#E8E8F6"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LkUser'
}
</script>
